import { Slider } from '@massilia/ui'

import { formatDuration } from '@/utils/format-duration'

import { FilterDrawer } from './filter-drawer'
import { useFiltersState } from './filters-state-context'

export interface DurationRange {
  max: number
  min: number
}

interface DurationFilterProps {
  bounds: DurationRange
}

export function DurationFilter({ bounds }: DurationFilterProps) {
  const {
    filters: { filterDurationMax, filterDurationMin },
    setFilters,
  } = useFiltersState()

  const hasCompleteRange = filterDurationMin !== undefined && filterDurationMax !== undefined
  // Mirror the result pages: a range is active only when both bounds exist.
  // A partial URL range should display the live full range, not [min, min].
  const currentMin = hasCompleteRange ? Math.max(filterDurationMin, bounds.min) : bounds.min
  const currentMax = hasCompleteRange ? Math.min(filterDurationMax, bounds.max) : bounds.max
  // Guarantee max >= min so the two thumbs are always distinguishable.
  const safeMax = Math.max(currentMin, currentMax)

  return (
    <FilterDrawer title="Durée par vol">
      <div className="space-y-4">
        <div className="flex items-center justify-between text-sm">
          <span className="text-gray-600">Durée</span>
          <span className="font-medium text-gray-700">
            {formatDuration(currentMin)} - {formatDuration(safeMax)}
          </span>
        </div>

        <Slider
          max={bounds.max}
          min={bounds.min}
          onValueChange={(values) => {
            setFilters({ filterDurationMax: values[1], filterDurationMin: values[0] })
          }}
          step={30} // 30 minutes steps
          value={[currentMin, safeMax]}
        />

        <div className="flex justify-between text-xs text-gray-500">
          <span>{formatDuration(bounds.min)}</span>
          <span>{formatDuration(bounds.max)}</span>
        </div>
      </div>
    </FilterDrawer>
  )
}
